<template>
  <div class="mb-50px resizeimage">
    <img v-if="step == 1" src="../../assets/images/1_clevas_regist_mail_active.png">
    <img v-if="step != 1" src="../../assets/images/1_regist_mail_inactive.png">
    <img v-if="step == 2" src="../../assets/images/2_clevas_regist_user_active.png">
    <img v-if="step != 2" src="../../assets/images/2_regist_user_inactive.png">
    <img v-if="step == 3" src="../../assets/images/3_clevas_complete_active.png">
    <img v-if="step != 3" src="../../assets/images/3_clevas_complete_inactive.png">
  </div>
</template>

<script>
  import 'babel-polyfill';
  export default {
    name: "UserFlow",
    components: { },
    props: {
      step: {
        type: Number,
        default: 1
      },
    },
  }
</script>
